export default class HazardDateTimeDetails {
    createdDateTime!: Date;
    modifiedDateTime!: Date;
    deleteDateTime!: Date;
}